import React, { useEffect, useRef, useState } from "react";
import { Tree } from "primereact/tree";
import { Button } from "react-bootstrap";
import { Toast } from "primereact/toast";

const ListOfUserGroup = ({ list, value, onChange }) => {
  return (
    <>
      <div className="card flex justify-content-center">
        <Tree
          value={list}
          selectionKeys={value}
          onSelectionChange={(e) => onChange(e.value)}
          className="w-full md:w-30rem rtl mdy-tree iran-sans "
          rendertreenode={(node) => (
            <span
              className={`tree-node${
                node?.children ? " tree-node-parent" : " tree-node-child"
              }`}
            >
              {node?.label}
            </span>
          )}
        />
      </div>
    </>
  );
};

export default ListOfUserGroup;
